"use client"

// src/components/slide.ts
var Slide = {
  baseStyle: {
    position: "fixed",
    zIndex: "fallback(jeice, 110)"
  },
  defaultProps: {
    placement: "right"
  }
};

export {
  Slide
};
//# sourceMappingURL=chunk-ECX4SPPJ.mjs.map